import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/slice';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _JSON$stringify from '@babel/runtime-corejs3/core-js-stable/json/stringify';
import _Set from '@babel/runtime-corejs3/core-js-stable/set';
import _Map from '@babel/runtime-corejs3/core-js-stable/map';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _someInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/some';
import _findIndexInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find-index';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import _findInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find';
import _sortInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/sort';
import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import React__default, { useMemo, useState, useCallback, useEffect, useRef } from 'react';
import classNames from 'classnames';
import '../../node_modules/react-dnd/dist/esm/af597232e4287e1eccfc726dc727db9ba15b2b54007e8cfc25e30ca7416d66b5.cfe-internal.js';
import { HTML5Backend } from '../../node_modules/react-dnd-html5-backend/dist/esm/bbf6cf49dbb2f98d8f0a51f1f574c80cb3782df09169471707d4a9364d593207.cfe-internal.js';
import useResizeObserver from '@react-hook/resize-observer';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import styles from './911805e7d0f3f24d5c4539dfbcbf0ca9410ef311f2044b4b999baa91b0b8e88b.cfe-internal.js';
import AdvancedTableColumnHeader from './c7e71467066408b3cad617862fadc3a2800e968b48079ad63a2cae3c91bd7d4d.cfe-internal.js';
import AdvancedTableCell from './1403f041c7a936c6bfc3b0c80c3e66a6dc4d853837fce799c6304a5f05e93124.cfe-internal.js';
import AdvancedTableRow from './dec85145444dcaa4355801d2d0813a097c216ec4bfcf4f52ca0677f3ba53644b.cfe-internal.js';
import AdvancedTableColumnHeaders from './fd0bfeccabcd5691838e73d70169b990f7cdf7c921c9062502a31a863ffd8d74.cfe-internal.js';
import AdvancedTableCheckbox from './8c6ca10725f3dae0d367d90cd25200f0b1e6693ec0ce0d67cf8cc2f04ca8ea0b.cfe-internal.js';
import AdvancedTableHiddenDescription from './2f870a9bad53457d7181c11a385d1e87876c30cfa9ca2cfeed46b2a626990734.cfe-internal.js';
import AdvancedTableDragPreview from './a9e6be84855199f114766b05f895c4736b1b654ea3a84c45d52c61409f8d9576.cfe-internal.js';
import '../../icons/index.es.js';
import '../629495c61f6f3ffdfe2248a13b452d018cea8d55bb88c94e497bf6f5395fc2fd.cfe-internal.js';
import AdvancedTablePagination from './6b45bc51ecddb3dcc7e0a3841c1e2c710d767cbfce0edaa139f1758982e63f6a.cfe-internal.js';
import AdvancedTableRowExpandButton from './5f8096b8456c49e7e3a2e5491cf56808cf9e148ba556ba8fa27b8189452cbdb7.cfe-internal.js';
import useId from '../../hooks/useId/df6d0ff48c086d34ec4e3589a05e8dd99a305947cee007fa9f94a6dd07ae8d17.cfe-internal.js';
import Dropdown from '../Dropdown/86a62832a5b51616e250e63d85e6a2e65a92b18243e63a5cbaedf2a4caeead37.cfe-internal.js';
import DropdownButton from '../Dropdown/e4b1ddbaf01adff19e387aec48526d0b0b2b2327998bc850542b3f4bb4eacfa4.cfe-internal.js';
import IconButton from '../IconButton/399631eebecc03da030561fb1a25c35c2d29c5e4645700b7fca3cf592ca75904.cfe-internal.js';
import EllipsisHorizontalIcon from '../../icons/components/6cff50c5b1055968e4d9caef3a8f2fe6fa611f63e408619999fa97bf8608a423.cfe-internal.js';
import DropdownList from '../Dropdown/38f544533ed811c651a2672712bff679b6fae971f08963b16ad2020d0643770c.cfe-internal.js';
import DropdownOption from '../Dropdown/147ddb2c3897a02b3c1eeced7971f50abdabcbd899deb56bd16c9f2217c1120c.cfe-internal.js';
import DropdownHeader from '../Dropdown/feae4a47535ddb22b08b984be3895bab5bb520f4fadeb927fd021c39379e9156.cfe-internal.js';
import concatIds from '../../utils/concatIds/99a67648a55cf7a2ee84ef14be5ebb23af1b4b19b5520388cd5eef8f3f3a1e28.cfe-internal.js';
import useControllableState from '../../hooks/useControllableState/fc7c2512fc1249f4837f2cb1f271d18191fa6aebd32c5f03023614c2b76711ef.cfe-internal.js';
import { useDidUpdate } from '../../hooks/useDidUpdate/f8ce5c85f293b5c4ca8be6bc5ac9f246003ac61cc91ab03b8814ccaab638a21a.cfe-internal.js';
import useEventCallback from '../../hooks/useEventCallback/0ebce52fac2aa94b4cad29a85740b8586bddbccb9acd7c8786ebbfef7b665ae0.cfe-internal.js';
import { setIsKeyboardUser, getIsKeyboardUser } from '../../utils/keyboardUser/20c2377f70ef9a94b4447542a95151abfb742a2428688e09defd93848a4c3b29.cfe-internal.js';
import { DndProvider } from '../../node_modules/react-dnd/dist/esm/core/7558c29730c7bd5811c1d9d9d839d635a66641a3f1493569c25bd5dbfa41d69b.cfe-internal.js';
import useLatest from '../../hooks/useLatest/1f51704b192f9e30a9862fa17b105c3f6454cca23cf8d6fb114db55de1c4e301.cfe-internal.js';
import wrapAround from '../../utils/wrapAround/1a639820434d46ac938b209a801f056dade6a52c7e66f2f20149353cdbcba005.cfe-internal.js';

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context16, _context17; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context16 = ownKeys(Object(t), !0)).call(_context16, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context17 = ownKeys(Object(t))).call(_context17, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var AdvancedTable = function AdvancedTable(_ref) {
  var _context10, _ref5;
  var externalColumnConfigs = _ref.columnConfigs,
    rowsPropExternal = _ref.rows,
    onRowsChange = _ref.onRowsChange,
    onRowSelect = _ref.onRowSelect,
    externalSelectedRowId = _ref.selectedRowId,
    onCheckedRowIdsChange = _ref.onCheckedRowIdsChange,
    externalCheckedRowIds = _ref.checkedRowIds,
    onSelectedSortOptionChange = _ref.onSelectedSortOptionChange,
    _ref$defaultSelectedS = _ref.defaultSelectedSortOption,
    defaultSelectedSortOption = _ref$defaultSelectedS === void 0 ? {
      columnId: '',
      index: -1,
      direction: 'none'
    } : _ref$defaultSelectedS,
    externalSelectedSortOption = _ref.selectedSortOption,
    _ref$disableUserPinna = _ref.disableUserPinnableColumns,
    disableUserPinnableColumns = _ref$disableUserPinna === void 0 ? false : _ref$disableUserPinna,
    _ref$initialPinnedCol = _ref.initialPinnedColumns,
    initialPinnedColumns = _ref$initialPinnedCol === void 0 ? [] : _ref$initialPinnedCol,
    exteralPinnedColumns = _ref.pinnedColumns,
    onPinnedColumnsChange = _ref.onPinnedColumnsChange,
    _ref$disableUserReord = _ref.disableUserReorderableColumns,
    disableUserReorderableColumns = _ref$disableUserReord === void 0 ? false : _ref$disableUserReord,
    externalColumnOrder = _ref.columnOrder,
    onColumnOrderChange = _ref.onColumnOrderChange,
    disableUserResizableColumns = _ref.disableUserResizableColumns,
    externalColumnWidths = _ref.columnWidths,
    onColumnWidthsChange = _ref.onColumnWidthsChange,
    externalTableId = _ref.id,
    rowsPerPage = _ref.rowsPerPage,
    initialPage = _ref.initialPage,
    onPageChange = _ref.onPageChange,
    paginationAriaLabel = _ref.paginationAriaLabel,
    ariaLabelledBy = _ref['aria-labelledby'],
    ariaLabel = _ref['aria-label'],
    externalAriaDescribedBy = _ref['aria-describedby'],
    dataTestId = _ref['data-testid'],
    rowActions = _ref.rowActions,
    rowActionsButtonAriaLabel = _ref.rowActionsButtonAriaLabel;
  // This handles an edge case where no rows are passed in
  // and the internal row transforms cause infinite state updates using a standard default assignment
  var stableDefaultArray = useMemo(function () {
    return [];
  }, []);
  var rowsProp = rowsPropExternal !== null && rowsPropExternal !== void 0 ? rowsPropExternal : stableDefaultArray;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    rows = _useState2[0],
    setRows = _useState2[1];
  var rowActionsColumnConfigId = useId();
  var rowActionsColumnConfig;
  var columnConfigs = useMemo(function () {
    return _toConsumableArray(externalColumnConfigs);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [externalColumnConfigs, rows] // columnConfigs has an implicit dependency on rows because it is initially computed using rows data
  );
  var _useState3 = useState(initialPage !== null && initialPage !== void 0 ? initialPage : 1),
    _useState4 = _slicedToArray(_useState3, 2),
    currentPage = _useState4[0],
    setCurrentPage = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    tableHeight = _useState6[0],
    setTableHeight = _useState6[1];
  var getPaginatedRowIndex = useCallback(function (universalRowIndex) {
    return rowsPerPage ? universalRowIndex + rowsPerPage * (currentPage - 1) : universalRowIndex;
  }, [rowsPerPage, currentPage]);
  var paginatedRows = useMemo(function () {
    if (!rows || !rowsPerPage || !currentPage) {
      return null;
    }
    var startingRowIndex = (currentPage - 1) * rowsPerPage;
    var endingRowIndex = startingRowIndex + rowsPerPage;
    return _sliceInstanceProperty(rows).call(rows, startingRowIndex, endingRowIndex);
  }, [rows, rowsPerPage, currentPage]);
  useEffect(function () {
    if (rows && rowsPerPage) {
      var pageCount = Math.ceil(rows.length / rowsPerPage);
      if (currentPage > pageCount) setCurrentPage(Math.max(pageCount, 1));
    }
  }, [rows, rowsPerPage, paginatedRows, currentPage]);
  if (rowActions && columnConfigs[columnConfigs.length - 1].id !== rowActionsColumnConfigId) {
    rowActionsColumnConfig = {
      id: rowActionsColumnConfigId,
      width: '44px',
      alignment: 'center',
      renderCellContent: function renderCellContent(_ref2) {
        var rowIndex = _ref2.rowIndex,
          isEditing = _ref2.isEditing,
          focusCell = _ref2.focusCell,
          focusableElementRef = _ref2.focusableElementRef;
        return /*#__PURE__*/React__default.createElement(Dropdown, {
          value: 0
        }, /*#__PURE__*/React__default.createElement(DropdownButton, null, /*#__PURE__*/React__default.createElement(IconButton, {
          "aria-label": rowActionsButtonAriaLabel,
          tabIndex: isEditing ? 0 : -1,
          ref: focusableElementRef,
          onKeyDown: function onKeyDown(e) {
            if (e.key === 'Escape') {
              focusCell();
            }
          }
        }, /*#__PURE__*/React__default.createElement(EllipsisHorizontalIcon, null))), /*#__PURE__*/React__default.createElement(DropdownList, {
          className: styles.rowActionMenuPane
        }, !rows ? [] : rowActions === null || rowActions === void 0 ? void 0 : _mapInstanceProperty(rowActions).call(rowActions, function (actionGroup, groupIndex) {
          var _actionGroup$actions;
          var row = rows[rowIndex];
          var actions = !row ? [] : (_actionGroup$actions = actionGroup.actions) === null || _actionGroup$actions === void 0 ? void 0 : _mapInstanceProperty(_actionGroup$actions).call(_actionGroup$actions, function (action, actionIndex) {
            var _context;
            return /*#__PURE__*/React__default.createElement(DropdownOption
            // React Docs: "We don't recommend using indexes for keys if the order of items may change." These will not change; the alternative is to require an id from the consumer.
            // eslint-disable-next-line react/no-array-index-key
            , {
              key: _concatInstanceProperty(_context = "".concat(groupIndex, "-")).call(_context, actionIndex),
              disabled: typeof action.isDisabled === 'function' ? action.isDisabled(row && row.rowPropReference) : action.isDisabled,
              onSelect: function onSelect() {
                return action.action(row && row.rowPropReference);
              },
              value: "",
              label: ""
            }, action.label);
          });
          if (actionGroup.header) {
            return /*#__PURE__*/React__default.createElement(DropdownHeader
            // eslint-disable-next-line react/no-array-index-key
            , {
              key: groupIndex,
              title: actionGroup.header
            }, actions);
          }
          return actions;
        })));
      },
      headerLabel: ''
    };
    columnConfigs.push(rowActionsColumnConfig);
  }
  var tableRef = useRef(null);
  var hasOnRowSelect = typeof onRowSelect === 'function';
  var hasCheckboxColumn = typeof onCheckedRowIdsChange === 'function';
  var hasFocusableRows = hasOnRowSelect || hasCheckboxColumn;
  var headerRowIndex = -1; // The header row (the first row in the table) gets an index of -1 so that the data rows can be zero-indexed
  var minRowIndex = useMemo(function () {
    return rowsPerPage ? rowsPerPage * (currentPage - 1) : 0;
  }, [rowsPerPage, currentPage]);
  var maxRowIndex = useMemo(function () {
    return !rows ? 0 : rowsPerPage ? Math.min(rowsPerPage + rowsPerPage * (currentPage - 1) - 1, rows.length - 1) : rows.length - 1;
  }, [rowsPerPage, currentPage, rows]);
  var maxRowDepth = useMemo(function () {
    return !rows ? 0 : Math.max.apply(Math, _toConsumableArray(_mapInstanceProperty(rows).call(rows, function (r) {
      return r.depth;
    })));
  }, [rows]);
  var widthBufferWidth = 36;
  var columnWidthBuffers = useMemo(function () {
    var buffers = [0];
    for (var i = 0; i < maxRowDepth + 1; i += 1) {
      buffers[i] = widthBufferWidth * (maxRowDepth - i);
    }
    return buffers;
  }, [maxRowDepth]);
  var minColumnIndex = hasFocusableRows ? -1 : 0; // When entire rows are focusable, they get an index of -1 so that the columns can be zero-indexed
  var maxColumnIndex = columnConfigs.length - 1;
  var tableId = useId(externalTableId);
  var arrowKeyDescriptionId = "".concat(tableId, "-arrowKeyDescription");
  var rowActionDescriptionId = "".concat(tableId, "-rowActionDescription");
  var rowCheckboxDescriptionId = "".concat(tableId, "-rowCheckboxDescription");
  useResizeObserver(tableRef, function (entry) {
    setTableHeight(entry.contentRect.height);
  });
  var ariaDescribedBy = concatIds(externalAriaDescribedBy, arrowKeyDescriptionId, hasOnRowSelect && rowActionDescriptionId, hasCheckboxColumn && rowCheckboxDescriptionId);
  var _useControllableState = useControllableState(initialPinnedColumns, onPinnedColumnsChange, exteralPinnedColumns),
    _useControllableState2 = _slicedToArray(_useControllableState, 2),
    pinnedColumns = _useControllableState2[0],
    setPinnedColumns = _useControllableState2[1];
  var _useControllableState3 = useControllableState({}, onColumnWidthsChange, externalColumnWidths),
    _useControllableState4 = _slicedToArray(_useControllableState3, 2),
    columnWidths = _useControllableState4[0],
    setColumnWidths = _useControllableState4[1];
  var columnConfigsOrder = useMemo(function () {
    return _mapInstanceProperty(columnConfigs).call(columnConfigs, function (c) {
      return c.id;
    });
  }, [columnConfigs]);
  var _useState7 = useState(columnConfigsOrder),
    _useState8 = _slicedToArray(_useState7, 2),
    internalColumnOrder = _useState8[0],
    setInternalColumnOrder = _useState8[1];

  // If columnConfigs changes, the internal column order may need to be updated (this is why useControllableState isn't being used).
  useDidUpdate(function () {
    setInternalColumnOrder(columnConfigsOrder);
  }, [_JSON$stringify(columnConfigsOrder)]);
  var columnOrder = externalColumnOrder !== null && externalColumnOrder !== void 0 ? externalColumnOrder : internalColumnOrder;
  var setColumnOrder = useEventCallback(function (value) {
    var newColumnOrder = typeof value === 'function' ? value(columnOrder) : value;
    setInternalColumnOrder(newColumnOrder);
    onColumnOrderChange === null || onColumnOrderChange === void 0 || onColumnOrderChange(newColumnOrder);
  });
  var _useMemo = useMemo(function () {
      var _context2;
      // Set and Map used for faster lookups
      var pinnedColumnsSet = new _Set(pinnedColumns);
      var columnConfigsMap = new _Map();
      _forEachInstanceProperty(columnConfigs).call(columnConfigs, function (c) {
        columnConfigsMap.set(c.id, c);
      });
      var pinnedColumnConfigs = _mapInstanceProperty(pinnedColumns).call(pinnedColumns, function (id) {
        return columnConfigsMap.get(id);
      });
      var unpinnedColumnOrder = _filterInstanceProperty(columnOrder).call(columnOrder, function (id) {
        return !pinnedColumnsSet.has(id) && columnConfigsMap.has(id);
      });
      var unpinnedColumnConfigs = _mapInstanceProperty(unpinnedColumnOrder).call(unpinnedColumnOrder, function (id) {
        return columnConfigsMap.get(id);
      });
      var pinnedUnpinnedColumnOrder = _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(_mapInstanceProperty(pinnedColumnConfigs).call(pinnedColumnConfigs, function (c) {
        return c.id;
      })), _toConsumableArray(_mapInstanceProperty(unpinnedColumnConfigs).call(unpinnedColumnConfigs, function (c) {
        return c.id;
      })));
      return {
        pinnedColumnConfigs: pinnedColumnConfigs,
        unpinnedColumnConfigs: unpinnedColumnConfigs,
        pinnedUnpinnedColumnOrder: pinnedUnpinnedColumnOrder
      };
    }, [columnConfigs, pinnedColumns, columnOrder]),
    pinnedColumnConfigs = _useMemo.pinnedColumnConfigs,
    unpinnedColumnConfigs = _useMemo.unpinnedColumnConfigs,
    pinnedUnpinnedColumnOrder = _useMemo.pinnedUnpinnedColumnOrder;
  var _useControllableState5 = useControllableState('', undefined, externalSelectedRowId),
    _useControllableState6 = _slicedToArray(_useControllableState5, 2),
    selectedRowId = _useControllableState6[0],
    setSelectedRowId = _useControllableState6[1];
  var _useControllableState7 = useControllableState([], onCheckedRowIdsChange, externalCheckedRowIds),
    _useControllableState8 = _slicedToArray(_useControllableState7, 2),
    checkedRowIds = _useControllableState8[0],
    setCheckedRowIds = _useControllableState8[1];
  var _useControllableState9 = useControllableState(defaultSelectedSortOption, onSelectedSortOptionChange, externalSelectedSortOption),
    _useControllableState10 = _slicedToArray(_useControllableState9, 2),
    selectedSortOption = _useControllableState10[0],
    setSelectedSortOption = _useControllableState10[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    dragSource = _useState10[0],
    setDragSource = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    dropTarget = _useState12[0],
    setDropTarget = _useState12[1];
  var _useState13 = useState(),
    _useState14 = _slicedToArray(_useState13, 2),
    dropTargetSide = _useState14[0],
    setDropTargetSide = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    lastToggledRowId = _useState16[0],
    setLastToggledRowId = _useState16[1];
  // Enables disabling row hover styles when hovering on the checkbox. Needed since a CSS parent selector doesn't exist.
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isCheckboxHovered = _useState18[0],
    setIsCheckboxHovered = _useState18[1];

  // Enables using Set.prototype.has() vs Array.prototype.includes() for better performance at scale
  var _useState19 = useState(new _Set(checkedRowIds)),
    _useState20 = _slicedToArray(_useState19, 2),
    checkedRowIdsSet = _useState20[0],
    setCheckedRowIdsSet = _useState20[1];
  useSortedRows({
    columnConfigs: columnConfigs,
    onRowsChange: onRowsChange,
    selectedSortOption: selectedSortOption,
    setCurrentPage: setCurrentPage
  });
  var mapExternalRowToInternalRows = useCallback(function (row, depthSize, depthIndex, parentId) {
    var depth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var mappedRows = [];
    var hasChildRows = !!row.childRows && row.childRows.length > 0;
    mappedRows.push({
      id: row.id,
      data: row.data,
      hasChildRows: hasChildRows,
      parentId: parentId,
      depth: depth,
      depthSize: depthSize,
      depthIndex: depthIndex,
      isExpanded: row.isExpanded,
      rowPropReference: row
    });
    if (row.isExpanded && row.childRows !== undefined && hasChildRows) {
      var _context3;
      _forEachInstanceProperty(_context3 = row.childRows).call(_context3, function (child, i) {
        mappedRows = _concatInstanceProperty(mappedRows).call(mappedRows, mapExternalRowToInternalRows(child, row.childRows !== undefined ? row.childRows.length : 0, i, row.id, depth + 1));
      });
    }
    return mappedRows;
  }, []);
  useEffect(function () {
    var filteredRows = [];
    _forEachInstanceProperty(rowsProp).call(rowsProp, function (row, i) {
      filteredRows = _concatInstanceProperty(filteredRows).call(filteredRows, mapExternalRowToInternalRows(row, rowsProp.length + 1, i + 1) // add 1 to account for table header
      );
    });
    setRows(filteredRows);
  }, [rowsProp, mapExternalRowToInternalRows]);
  useEffect(function () {
    setCheckedRowIdsSet(new _Set(checkedRowIds));
  }, [checkedRowIds]);
  var _useFocusState = useFocusState({
      headerRowIndex: headerRowIndex,
      maxRowIndex: maxRowIndex,
      minColumnIndex: minColumnIndex,
      maxColumnIndex: maxColumnIndex,
      hasFocusableRows: hasFocusableRows,
      pinnedUnpinnedColumnOrder: pinnedUnpinnedColumnOrder,
      tableRef: tableRef,
      currentPage: currentPage
    }),
    focusedRowIndex = _useFocusState.focusedRowIndex,
    focusedColumnIndex = _useFocusState.focusedColumnIndex,
    updateRowFocusIndex = _useFocusState.updateRowFocusIndex,
    updateColumnFocusIndex = _useFocusState.updateColumnFocusIndex,
    setFocusedColumnId = _useFocusState.setFocusedColumnId,
    createRef = _useFocusState.createRef,
    createPinnedContainerRef = _useFocusState.createPinnedContainerRef,
    cellRefs = _useFocusState.cellRefs;
  var getAllRowIds = useCallback(function () {
    var rowsToScan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rowsProp;
    var ids = [];
    _forEachInstanceProperty(rowsToScan).call(rowsToScan, function (row) {
      ids.push(row.id);
      if (row.childRows && row.childRows.length) {
        ids = _concatInstanceProperty(ids).call(ids, getAllRowIds(row.childRows));
      }
    });
    return ids;
  }, [rowsProp]);
  var totalRowsCountWithExpansion = useMemo(function () {
    return getAllRowIds().length;
  }, [getAllRowIds]);
  var hasExpandableRows = useMemo(function () {
    return rows === null || rows === void 0 ? void 0 : _someInstanceProperty(rows).call(rows, function (_ref3) {
      var hasChildRows = _ref3.hasChildRows;
      return hasChildRows;
    });
  }, [rows]);
  var updateExpandedRowIds = function updateExpandedRowIds(index, expand) {
    if (!rows || !rows[index]) {
      return;
    }
    var _rows$index = rows[index],
      isExpanded = _rows$index.isExpanded,
      rowPropReference = _rows$index.rowPropReference;
    if (isExpanded && expand !== true) {
      rowPropReference.isExpanded = false;
    } else if (expand !== false) {
      rowPropReference.isExpanded = true;
    }
    onRowsChange === null || onRowsChange === void 0 || onRowsChange(_toConsumableArray(rowsProp));
  };
  var getLastToggledRowIndex = function getLastToggledRowIndex() {
    var index = rows === null || rows === void 0 ? void 0 : _findIndexInstanceProperty(rows).call(rows, function (_ref4) {
      var id = _ref4.id;
      return id === lastToggledRowId;
    });
    return index === -1 ? 0 : index;
  };
  var getCheckboxStateForRow = function getCheckboxStateForRow(row) {
    var _context4;
    if (checkedRowIdsSet.has(row.id)) {
      return 'true';
    }
    if (row.hasChildRows && _someInstanceProperty(_context4 = getAllRowIds(row.rowPropReference.childRows)).call(_context4, function (id) {
      return checkedRowIdsSet.has(id);
    })) {
      return 'mixed';
    }
    return 'false';
  };
  var handleColumnHeaderCheckboxToggle = function handleColumnHeaderCheckboxToggle() {
    setLastToggledRowId('');
    if (checkedRowIds.length === totalRowsCountWithExpansion) {
      setCheckedRowIds([]);
    } else {
      setCheckedRowIds(getAllRowIds());
    }
  };
  var multiUpdateCheckedRowIds = function multiUpdateCheckedRowIds(startIndex, endIndex) {
    var _rows$endIndex;
    if (!rows || startIndex === headerRowIndex || endIndex === headerRowIndex) {
      return;
    }
    var endRowId = rows === null || rows === void 0 || (_rows$endIndex = rows[endIndex]) === null || _rows$endIndex === void 0 ? void 0 : _rows$endIndex.id;
    var isEndIndexChecked = checkedRowIdsSet.has(endRowId);
    var newCheckedRowIds = _toConsumableArray(checkedRowIds);
    var increment = startIndex < endIndex ? 1 : -1;
    var _loop = function _loop() {
      var _rows$i = rows[i],
        rowId = _rows$i.id,
        hasChildRows = _rows$i.hasChildRows,
        rowPropReference = _rows$i.rowPropReference;
      if (isEndIndexChecked) {
        var idsToUncheck = [rowId];
        if (hasChildRows) {
          idsToUncheck = _concatInstanceProperty(idsToUncheck).call(idsToUncheck, getAllRowIds(rowPropReference.childRows));
        }
        if (hasChildRows) {
          idsToUncheck = _concatInstanceProperty(idsToUncheck).call(idsToUncheck, getAllRowIds(rowPropReference.childRows));
        }
        newCheckedRowIds = _filterInstanceProperty(newCheckedRowIds).call(newCheckedRowIds, function (id) {
          return !_includesInstanceProperty(idsToUncheck).call(idsToUncheck, id);
        });
      } else if (!checkedRowIdsSet.has(rowId)) {
        var idsToCheck = [rowId];
        if (hasChildRows) {
          idsToCheck = _concatInstanceProperty(idsToCheck).call(idsToCheck, getAllRowIds(rowPropReference.childRows));
        }
        newCheckedRowIds = _concatInstanceProperty(newCheckedRowIds).call(newCheckedRowIds, idsToCheck);
      }
    };
    for (var i = startIndex; i !== endIndex + increment; i += increment) {
      _loop();
    }
    setLastToggledRowId(endRowId);
    setCheckedRowIds(newCheckedRowIds);
  };
  var singleUpdateCheckedRowIds = function singleUpdateCheckedRowIds(index) {
    if (!rows) {
      return;
    }
    var _rows$index2 = rows[index],
      rowId = _rows$index2.id,
      rowPropReference = _rows$index2.rowPropReference,
      hasChildRows = _rows$index2.hasChildRows;
    setLastToggledRowId(rowId);
    if (checkedRowIdsSet.has(rowId)) {
      var idsToUncheck = [rowId];
      if (hasChildRows) {
        idsToUncheck = _concatInstanceProperty(idsToUncheck).call(idsToUncheck, getAllRowIds(rowPropReference.childRows));
      }
      setCheckedRowIds(_filterInstanceProperty(checkedRowIds).call(checkedRowIds, function (id) {
        return !_includesInstanceProperty(idsToUncheck).call(idsToUncheck, id);
      }));
    } else {
      var _context6;
      var idsToCheck = [rowId];
      if (hasChildRows) {
        var _context5;
        idsToCheck = _concatInstanceProperty(idsToCheck).call(idsToCheck, _filterInstanceProperty(_context5 = getAllRowIds(rowPropReference.childRows)).call(_context5, function (r) {
          return !checkedRowIdsSet.has(r);
        }));
      }
      setCheckedRowIds(_concatInstanceProperty(_context6 = []).call(_context6, _toConsumableArray(checkedRowIds), _toConsumableArray(idsToCheck)));
    }
  };
  var onCellFocus = function onCellFocus(rowIndex, columnIndex) {
    return function () {
      updateRowFocusIndex(rowIndex);
      updateColumnFocusIndex(columnIndex);
    };
  };
  var onRowFocus = function onRowFocus(rowIndex, columnIndex) {
    return function (e) {
      if (e.target !== e.currentTarget) return;
      updateRowFocusIndex(rowIndex);
      updateColumnFocusIndex(columnIndex);
    };
  };
  var onKeyDown = function onKeyDown(rowIndex) {
    return function (e) {
      if (!rows || e.target !== e.currentTarget) return; // Ensures only rows/cells trigger grid navigation
      var newFocusedRowIndex;
      var currentRow = rows[rowIndex];
      var rowOrFirstColumnIsFocused = focusedColumnIndex <= 0;
      var rowCanExpand = (currentRow === null || currentRow === void 0 ? void 0 : currentRow.hasChildRows) && !(currentRow !== null && currentRow !== void 0 && currentRow.isExpanded);
      var rowCanCollapse = (currentRow === null || currentRow === void 0 ? void 0 : currentRow.hasChildRows) && (currentRow === null || currentRow === void 0 ? void 0 : currentRow.isExpanded);
      switch (e.key) {
        case 'ArrowUp':
          e.preventDefault(); // prevent scroll
          setIsKeyboardUser(true);
          newFocusedRowIndex = updateRowFocusIndex(rowIndex === minRowIndex ? headerRowIndex : rowIndex - 1);
          if (e.shiftKey) {
            multiUpdateCheckedRowIds(rowIndex, newFocusedRowIndex);
          }
          break;
        case 'ArrowDown':
          e.preventDefault(); // prevent scroll
          setIsKeyboardUser(true);
          newFocusedRowIndex = updateRowFocusIndex(rowIndex === headerRowIndex ? minRowIndex : rowIndex + 1);
          if (e.shiftKey) {
            multiUpdateCheckedRowIds(rowIndex, newFocusedRowIndex);
          }
          break;
        case 'ArrowLeft':
          e.preventDefault(); // prevent scroll
          setIsKeyboardUser(true);
          // If the row is expanded and on the first cell, collapse the row
          if (e.shiftKey || rowOrFirstColumnIsFocused && rowCanCollapse) {
            updateExpandedRowIds(rowIndex, false);
            break;
          }
          updateColumnFocusIndex(focusedColumnIndex - 1);
          break;
        case 'ArrowRight':
          e.preventDefault(); // prevent scroll
          setIsKeyboardUser(true);
          // If the row is collapsed and on the first cell, expand the row
          if (e.shiftKey || rowOrFirstColumnIsFocused && rowCanExpand) {
            updateExpandedRowIds(rowIndex, true);
            break;
          }
          updateColumnFocusIndex(focusedColumnIndex + 1);
          break;
        case 'PageUp':
          e.preventDefault(); // prevent scroll
          setIsKeyboardUser(true);
          updateRowFocusIndex(headerRowIndex);
          break;
        case 'PageDown':
          e.preventDefault(); // prevent scroll
          setIsKeyboardUser(true);
          updateRowFocusIndex(maxRowIndex);
          break;
        case 'Home':
          e.preventDefault(); // prevent scroll
          setIsKeyboardUser(true);
          updateColumnFocusIndex(minColumnIndex);
          if (e.ctrlKey) {
            updateRowFocusIndex(headerRowIndex);
          }
          break;
        case 'End':
          e.preventDefault(); // prevent scroll
          setIsKeyboardUser(true);
          updateColumnFocusIndex(maxColumnIndex);
          if (e.ctrlKey) {
            updateRowFocusIndex(maxRowIndex);
          }
          break;
        case ' ':
          e.preventDefault(); // prevent scroll
          setIsKeyboardUser(true);
          if (rowIndex === headerRowIndex) {
            handleColumnHeaderCheckboxToggle();
          } else if (e.shiftKey) {
            multiUpdateCheckedRowIds(getLastToggledRowIndex(), rowIndex);
          } else {
            singleUpdateCheckedRowIds(rowIndex);
          }
          break;
        default:
          break;
      }
    };
  };
  var isFinalNonRowActionsColumn = function isFinalNonRowActionsColumn(columnIndex) {
    var columnCount = unpinnedColumnConfigs.length + pinnedColumnConfigs.length;
    var finalColumnIsRowActions = Boolean(rowActions);
    var finalNonRowActionsColumnIndex = columnCount - (finalColumnIsRowActions ? 2 : 1);
    return columnIndex === finalNonRowActionsColumnIndex;
  };
  var getColumnHeaderProps = function getColumnHeaderProps(columnConfig, columnIndex, isPinned) {
    var _context7, _columnWidths$id;
    var rowIndex = headerRowIndex;
    var id = columnConfig.id,
      headerLabel = columnConfig.headerLabel,
      width = columnConfig.width,
      alignment = columnConfig.alignment,
      sortOptions = columnConfig.sortOptions;
    var isRowActionMenuColumn = rowActionsColumnConfigId === id;
    return {
      id: id,
      isRowActionMenuColumn: isRowActionMenuColumn,
      isFinalNonRowActionsColumn: isFinalNonRowActionsColumn(columnIndex),
      'data-testid': dataTestId && id ? _concatInstanceProperty(_context7 = "".concat(dataTestId, "-")).call(_context7, id) : undefined,
      label: headerLabel,
      width: (_columnWidths$id = columnWidths[id]) !== null && _columnWidths$id !== void 0 ? _columnWidths$id : width,
      widthBuffer: columnIndex === 0 && maxRowDepth > 0 ? columnWidthBuffers[0] : undefined,
      onWidthChange: disableUserResizableColumns || isRowActionMenuColumn ? undefined : function (newWidth) {
        setColumnWidths(function (currentColumnWidths) {
          var newColumnWidths = _objectSpread({}, currentColumnWidths);
          newColumnWidths[id] = newWidth;
          return newColumnWidths;
        });
      },
      alignment: alignment,
      columnIndex: columnIndex,
      isFocused: rowIndex === focusedRowIndex && columnIndex === focusedColumnIndex,
      onFocus: onCellFocus(rowIndex, columnIndex),
      setFocusedColumnId: setFocusedColumnId,
      sortOptions: sortOptions,
      selectedSortOption: selectedSortOption,
      setSelectedSortOption: setSelectedSortOption,
      onKeyDown: onKeyDown(rowIndex),
      minUnpinnedColumnIndex: pinnedColumns.length,
      maxUnpinnedColumnIndex: maxColumnIndex,
      disableUserPinnableColumns: disableUserPinnableColumns,
      isPinned: isPinned,
      setPinnedColumns: setPinnedColumns,
      disableUserReorderableColumns: disableUserReorderableColumns,
      setColumnOrder: setColumnOrder,
      isDragging: dragSource === id,
      setDragSource: setDragSource,
      setDropTarget: setDropTarget,
      setDropTargetSide: setDropTargetSide,
      dropTargetSide: dropTarget === id ? dropTargetSide : undefined,
      tableId: tableId,
      tableHeight: tableHeight,
      key: id,
      ref: createRef(rowIndex, columnIndex)
    };
  };
  var getCellProps = function getCellProps(columnConfig, columnIndex, data, rowIndex, rowId, depth) {
    var _columnWidths$columnI, _context8, _context9;
    var columnId = columnConfig.id,
      width = columnConfig.width,
      alignment = columnConfig.alignment,
      renderCellContent = columnConfig.renderCellContent,
      isCellContentInteractive = columnConfig.isCellContentInteractive;
    var value = data[columnId];
    return {
      value: value,
      isFinalNonRowActionsColumn: isFinalNonRowActionsColumn(columnIndex),
      setValue: function setValue(newValue) {
        var newRows = _toConsumableArray(rowsProp);
        newRows[rowIndex].data[columnId] = newValue;
        onRowsChange === null || onRowsChange === void 0 || onRowsChange(newRows);
      },
      renderCellContent: renderCellContent,
      isCellContentInteractive: isCellContentInteractive,
      width: (_columnWidths$columnI = columnWidths[columnId]) !== null && _columnWidths$columnI !== void 0 ? _columnWidths$columnI : width,
      widthBuffer: columnIndex === 0 && maxRowDepth > 0 ? columnWidthBuffers[depth] : undefined,
      alignment: alignment,
      rowId: rowId,
      columnId: columnId,
      rowIndex: rowIndex,
      columnIndex: columnIndex,
      'data-testid': dataTestId && rowId && columnId ? _concatInstanceProperty(_context8 = _concatInstanceProperty(_context9 = "".concat(dataTestId, "-cell-")).call(_context9, rowId, "-")).call(_context8, columnId) : undefined,
      isFocused: rowIndex === focusedRowIndex && columnIndex === focusedColumnIndex,
      onFocus: onCellFocus(rowIndex, columnIndex),
      onKeyDown: onKeyDown(rowIndex),
      isDragging: columnId === dragSource,
      key: columnId,
      ref: createRef(rowIndex, columnIndex)
    };
  };
  return /*#__PURE__*/React__default.createElement(DndProvider, {
    backend: HTML5Backend
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.advancedTable,
    role: hasExpandableRows ? 'treegrid' : 'grid',
    "aria-multiselectable": hasExpandableRows && hasCheckboxColumn ? true : undefined,
    "aria-rowcount": rows ? rows.length + 1 : 0,
    "aria-colcount": columnConfigs.length,
    "aria-labelledby": ariaLabelledBy,
    "aria-label": ariaLabel,
    "aria-describedby": ariaDescribedBy,
    "data-testid": dataTestId,
    ref: tableRef
  }, dragSource && !disableUserPinnableColumns && !disableUserReorderableColumns ? /*#__PURE__*/React__default.createElement(AdvancedTableDragPreview, {
    tableRef: tableRef,
    columnHeaderRefs: cellRefs.current[-1]
  }) : null, /*#__PURE__*/React__default.createElement(AdvancedTableHiddenDescription, {
    id: arrowKeyDescriptionId,
    messageKey: "advancedTable.arrowKeyDescription"
  }), hasOnRowSelect && /*#__PURE__*/React__default.createElement(AdvancedTableHiddenDescription, {
    id: rowActionDescriptionId,
    messageKey: "advancedTable.rowActionDescription"
  }), hasCheckboxColumn && /*#__PURE__*/React__default.createElement(AdvancedTableHiddenDescription, {
    id: rowCheckboxDescriptionId,
    messageKey: "advancedTable.rowCheckboxDescription"
  }), /*#__PURE__*/React__default.createElement("div", {
    role: "rowgroup",
    className: classNames(styles.advancedTableColumnHeadersRowGroup, styles.advancedTableRowGroup)
  }, /*#__PURE__*/React__default.createElement(AdvancedTableColumnHeaders, {
    "aria-rowindex": hasExpandableRows ? undefined : 1,
    "aria-level": hasExpandableRows ? 1 : undefined // aria-level is one-indexed
    ,
    "aria-setsize": hasExpandableRows ? rowsProp.length + 1 : undefined,
    "aria-posinset": hasExpandableRows ? 1 : undefined // aria-posinset is one-indexed
    ,
    isFocusable: hasFocusableRows,
    isFocused: headerRowIndex === focusedRowIndex && minColumnIndex === focusedColumnIndex,
    onKeyDown: onKeyDown(headerRowIndex),
    onFocus: onRowFocus(headerRowIndex, minColumnIndex),
    ref: createRef(headerRowIndex, -1)
  }, hasCheckboxColumn || pinnedColumnConfigs.length || hasExpandableRows ? /*#__PURE__*/React__default.createElement("div", {
    role: "presentation",
    className: classNames(styles.pinnedContainer, styles.advancedTableRowChild),
    ref: createPinnedContainerRef(headerRowIndex)
  }, hasCheckboxColumn && /*#__PURE__*/React__default.createElement(AdvancedTableCheckbox, {
    state: checkedRowIds.length === totalRowsCountWithExpansion ? 'true' : checkedRowIds.length === 0 ? 'false' : 'mixed',
    isRowFocused: headerRowIndex === focusedRowIndex,
    onClick: handleColumnHeaderCheckboxToggle,
    onFocus: onRowFocus(headerRowIndex, minColumnIndex),
    variant: "header"
  }), hasExpandableRows && /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles.advancedTableExpandRowSpacer, styles.header),
    style: {
      width: "".concat(widthBufferWidth, "px")
    }
  }), _mapInstanceProperty(pinnedColumnConfigs).call(pinnedColumnConfigs, function (columnConfigs, i) {
    var props = getColumnHeaderProps(columnConfigs, i, true);
    return /*#__PURE__*/React__default.createElement(AdvancedTableColumnHeader, props);
  })) : undefined, _mapInstanceProperty(unpinnedColumnConfigs).call(unpinnedColumnConfigs, function (columnConfigs, i) {
    var props = getColumnHeaderProps(columnConfigs, i + pinnedColumnConfigs.length, false);
    return /*#__PURE__*/React__default.createElement(AdvancedTableColumnHeader, props);
  }))), /*#__PURE__*/React__default.createElement("div", {
    role: "rowgroup",
    className: styles.advancedTableRowGroup
  }, _mapInstanceProperty(_context10 = (_ref5 = paginatedRows !== null && paginatedRows !== void 0 ? paginatedRows : rows) !== null && _ref5 !== void 0 ? _ref5 : []).call(_context10, function (row, rowIndex) {
    var _context11, _context12, _context13, _context14;
    var rowId = row.id,
      data = row.data,
      isExpanded = row.isExpanded,
      _row$depth = row.depth,
      depth = _row$depth === void 0 ? 0 : _row$depth,
      depthSize = row.depthSize,
      depthIndex = row.depthIndex,
      rowPropReference = row.rowPropReference,
      parentId = row.parentId;
    var hasChildRows = rowPropReference.childRows && rowPropReference.childRows.length > 0;
    var paginatedRowIndex = getPaginatedRowIndex(rowIndex);
    var onSelect = function onSelect(e) {
      e.preventDefault(); // stops event from triggering on new target when focus is changed during onSelect
      if (hasOnRowSelect) {
        onRowSelect === null || onRowSelect === void 0 || onRowSelect(row.rowPropReference);
        setSelectedRowId(rowId);
      }
    };
    var onRowKeyDown = function onRowKeyDown(e) {
      if (e.target !== e.currentTarget) return;
      onKeyDown(paginatedRowIndex)(e);
      if (e.key === 'Enter') {
        onSelect(e);
      }
    };
    return /*#__PURE__*/React__default.createElement(AdvancedTableRow, {
      "aria-rowindex": hasExpandableRows ? undefined : paginatedRowIndex + 2 // aria-rowindex is one-indexed + the column headers row is the first row in the table
      ,
      "data-testid": dataTestId && rowId ? _concatInstanceProperty(_context11 = "".concat(dataTestId, "-row-")).call(_context11, rowId) : undefined,
      hasOnRowSelect: hasOnRowSelect,
      isFocusable: hasFocusableRows,
      isFocused: paginatedRowIndex === focusedRowIndex && minColumnIndex === focusedColumnIndex,
      isSelected: selectedRowId === rowId,
      isCheckboxHovered: isCheckboxHovered,
      onKeyDown: onRowKeyDown,
      onFocus: onRowFocus(paginatedRowIndex, minColumnIndex),
      onClick: function onClick(e) {
        return onSelect(e);
      },
      key: _concatInstanceProperty(_context12 = _concatInstanceProperty(_context13 = "".concat(rowId)).call(_context13, depth)).call(_context12, parentId),
      ref: createRef(paginatedRowIndex, minColumnIndex),
      "aria-expanded": hasChildRows ? !!isExpanded : undefined,
      "aria-level": hasExpandableRows ? depth + 1 : undefined // aria-level is one-indexed
      ,
      "aria-setsize": hasExpandableRows ? depthSize : undefined,
      "aria-posinset": hasExpandableRows ? depthIndex + 1 : undefined // aria-posinset is one-indexed
    }, hasCheckboxColumn || hasExpandableRows || pinnedColumnConfigs.length ? /*#__PURE__*/React__default.createElement("div", {
      className: classNames(styles.pinnedContainer, styles.advancedTableRowChild),
      ref: createPinnedContainerRef(paginatedRowIndex)
    }, hasCheckboxColumn && /*#__PURE__*/React__default.createElement(AdvancedTableCheckbox, {
      state: getCheckboxStateForRow(row),
      isRowFocused: paginatedRowIndex === focusedRowIndex,
      onClick: function onClick(e) {
        e.stopPropagation(); // prevent onRowSelect
        if (e.shiftKey) {
          multiUpdateCheckedRowIds(getLastToggledRowIndex(), paginatedRowIndex);
        } else {
          singleUpdateCheckedRowIds(paginatedRowIndex);
        }
      },
      onMouseEnter: function onMouseEnter() {
        return setIsCheckboxHovered(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setIsCheckboxHovered(false);
      },
      onFocus: onRowFocus(paginatedRowIndex, minColumnIndex)
    }), hasExpandableRows && /*#__PURE__*/React__default.createElement("div", {
      className: styles.advancedTableExpandRowSpacer,
      style: {
        width: "".concat(widthBufferWidth * (depth + 1), "px")
      }
    }, hasChildRows && /*#__PURE__*/React__default.createElement(AdvancedTableRowExpandButton, {
      "data-testid": dataTestId && rowId ? _concatInstanceProperty(_context14 = "".concat(dataTestId, "-row-")).call(_context14, rowId, "-expand-button") : undefined,
      isRowExpanded: !!isExpanded,
      onClick: function onClick(e) {
        e.stopPropagation(); // prevent onRowSelect
        e.preventDefault();
        updateExpandedRowIds(rowIndex);
      },
      onFocus: onRowFocus(rowIndex, minColumnIndex)
    })), _mapInstanceProperty(pinnedColumnConfigs).call(pinnedColumnConfigs, function (c, i) {
      var props = getCellProps(c, i, data, paginatedRowIndex, rowId, depth);
      return /*#__PURE__*/React__default.createElement(AdvancedTableCell, _extends({}, props, {
        "aria-rowindex": hasExpandableRows ? undefined : rowIndex + 2 // aria-rowindex is one-indexed + the column headers row is the first row in the table
        ,
        "aria-colindex": i + 1 // aria-colindex is one-indexed
      }));
    })) : undefined, _mapInstanceProperty(unpinnedColumnConfigs).call(unpinnedColumnConfigs, function (c, i) {
      var props = getCellProps(c, i + pinnedColumnConfigs.length, data, paginatedRowIndex, rowId, depth);
      return /*#__PURE__*/React__default.createElement(AdvancedTableCell, _extends({}, props, {
        className: styles.advancedTableRowChild,
        "aria-rowindex": hasExpandableRows ? undefined : rowIndex + 2 // aria-rowindex is one-indexed + the column headers row is the first row in the table
        ,
        "aria-colindex": i + 1 // aria-colindex is one-indexed
      }));
    }));
  })), rowsPerPage ? /*#__PURE__*/React__default.createElement(AdvancedTablePagination, {
    rowsPerPage: rowsPerPage,
    onPageChange: onPageChange,
    ariaLabel: paginationAriaLabel,
    rows: rowsProp,
    currentPage: currentPage,
    setCurrentPage: setCurrentPage
  }) : null));
};

// TODO: move hook to separate file
function useSortedRows(_ref6) {
  var columnConfigs = _ref6.columnConfigs,
    onRowsChange = _ref6.onRowsChange,
    selectedSortOption = _ref6.selectedSortOption,
    setCurrentPage = _ref6.setCurrentPage;
  var columnConfigsRef = useLatest(columnConfigs);
  var onRowsChangeRef = useLatest(onRowsChange);
  useDidUpdate(function () {
    var _columnConfigsRef$cur, _context15;
    var columnId = selectedSortOption.columnId,
      index = selectedSortOption.index;
    var sort = (_columnConfigsRef$cur = _findInstanceProperty(_context15 = columnConfigsRef.current).call(_context15, function (_ref7) {
      var id = _ref7.id;
      return id === columnId;
    })) === null || _columnConfigsRef$cur === void 0 || (_columnConfigsRef$cur = _columnConfigsRef$cur.sortOptions) === null || _columnConfigsRef$cur === void 0 || (_columnConfigsRef$cur = _columnConfigsRef$cur[index]) === null || _columnConfigsRef$cur === void 0 ? void 0 : _sortInstanceProperty(_columnConfigsRef$cur);
    if (typeof sort === 'function' && onRowsChangeRef.current) {
      onRowsChangeRef.current(sort(selectedSortOption));
      setCurrentPage(1);
    }
  }, [columnConfigsRef, onRowsChangeRef, selectedSortOption]);
}

// TODO: move hook to separate file
function useFocusState(_ref8) {
  var headerRowIndex = _ref8.headerRowIndex,
    maxRowIndex = _ref8.maxRowIndex,
    minColumnIndex = _ref8.minColumnIndex,
    maxColumnIndex = _ref8.maxColumnIndex,
    hasFocusableRows = _ref8.hasFocusableRows,
    pinnedUnpinnedColumnOrder = _ref8.pinnedUnpinnedColumnOrder,
    tableRef = _ref8.tableRef,
    currentPage = _ref8.currentPage;
  var cellRefs = useRef({});
  var pinnedContainersRef = useRef({});
  var _useState21 = useState(headerRowIndex),
    _useState22 = _slicedToArray(_useState21, 2),
    focusedRowIndex = _useState22[0],
    setFocusedRowIndex = _useState22[1];
  var _useState23 = useState(minColumnIndex),
    _useState24 = _slicedToArray(_useState23, 2),
    focusedColumnIndex = _useState24[0],
    setFocusedColumnIndex = _useState24[1];
  var _useState25 = useState(),
    _useState26 = _slicedToArray(_useState25, 2),
    focusedColumnId = _useState26[0],
    setFocusedColumnId = _useState26[1];
  var createRef = function createRef(rowIndex, columnIndex) {
    return function (node) {
      if (!cellRefs.current[rowIndex]) {
        cellRefs.current[rowIndex] = {};
      }
      cellRefs.current[rowIndex][columnIndex] = node;
    };
  };
  var createPinnedContainerRef = function createPinnedContainerRef(rowIndex) {
    return function (node) {
      pinnedContainersRef.current[rowIndex] = node;
    };
  };
  var updateRowFocusIndex = function updateRowFocusIndex(index) {
    var newIndex = wrapAround(index, headerRowIndex, maxRowIndex);
    setFocusedRowIndex(newIndex);
    return newIndex;
  };
  var updateColumnFocusIndex = function updateColumnFocusIndex(index) {
    var newIndex = wrapAround(index, minColumnIndex, maxColumnIndex);
    setFocusedColumnIndex(newIndex);
    return newIndex;
  };
  var focusCell = useEventCallback(function (cell) {
    // Manually scroll cells/rows into view if needed
    if (getIsKeyboardUser()) {
      var _tableRef$current, _cellRefs$current;
      var tablePos = (_tableRef$current = tableRef.current) === null || _tableRef$current === void 0 ? void 0 : _tableRef$current.getBoundingClientRect();
      var header = (_cellRefs$current = cellRefs.current) === null || _cellRefs$current === void 0 || (_cellRefs$current = _cellRefs$current[headerRowIndex]) === null || _cellRefs$current === void 0 ? void 0 : _cellRefs$current[-1];
      var headerPos = header === null || header === void 0 ? void 0 : header.getBoundingClientRect();
      var cellPos = cell === null || cell === void 0 ? void 0 : cell.getBoundingClientRect();

      // Vertical scroll
      if (cell !== header && !header.contains(cell)) {
        if (cellPos.top < headerPos.top + headerPos.height) {
          // Scroll down if cell covered by header
          tableRef.current.scrollTop -= headerPos.top + headerPos.height - cellPos.top;
        } else if (cellPos.top < tablePos.top) {
          // Scroll down if cell out of view above table
          tableRef.current.scrollTop -= tablePos.top - cellPos.top;
        } else if (cellPos.bottom > tablePos.bottom) {
          // Scroll up if cell out of view below table
          tableRef.current.scrollTop += cellPos.bottom - tablePos.bottom;
        }
      }

      // Horizontal scroll
      // Scroll left if an entire row is focused
      if (minColumnIndex === -1 && focusedColumnIndex === minColumnIndex) {
        tableRef.current.scrollLeft -= tablePos.left - cellPos.left;
      } else {
        var _pinnedContainersRef$;
        if (cellPos.left < tablePos.left) {
          // Scroll right if cell out of view to the left of the table
          tableRef.current.scrollLeft -= tablePos.left - cellPos.left;
        } else if (cellPos.right > tablePos.right) {
          // Scroll left if cell out of view to the right of the table
          tableRef.current.scrollLeft += cellPos.right - tablePos.right;
        }
        var pinnedContainer = (_pinnedContainersRef$ = pinnedContainersRef.current) === null || _pinnedContainersRef$ === void 0 ? void 0 : _pinnedContainersRef$[focusedRowIndex];
        var pinnedContainerPos = pinnedContainer === null || pinnedContainer === void 0 ? void 0 : pinnedContainer.getBoundingClientRect();
        cellPos = cell === null || cell === void 0 ? void 0 : cell.getBoundingClientRect();

        // Scroll right if cell covered by pinned columns
        if (pinnedContainer && cellPos.left < pinnedContainerPos.left + pinnedContainerPos.width && !pinnedContainer.contains(cell)) {
          tableRef.current.scrollLeft -= pinnedContainerPos.left + pinnedContainerPos.width - cellPos.left;
        }
      }
    }
    cell === null || cell === void 0 || cell.focus();
  });

  // Focus header cell when the focused column id changes. Used when pinning/unpinning columns since a new DOM element is created.
  useDidUpdate(function () {
    if (focusedColumnId) {
      var _cellRefs$current2;
      var columnIndex = _indexOfInstanceProperty(pinnedUnpinnedColumnOrder).call(pinnedUnpinnedColumnOrder, focusedColumnId);
      focusCell((_cellRefs$current2 = cellRefs.current) === null || _cellRefs$current2 === void 0 || (_cellRefs$current2 = _cellRefs$current2[focusedRowIndex]) === null || _cellRefs$current2 === void 0 ? void 0 : _cellRefs$current2[columnIndex]);
      setFocusedColumnIndex(columnIndex);
      setFocusedColumnId(undefined);
    }
  }, [focusedColumnId, pinnedUnpinnedColumnOrder]);

  // Focus cell when the focused indices change
  useDidUpdate(function () {
    var _cellRefs$current3;
    var newFocusedCell = (_cellRefs$current3 = cellRefs.current) === null || _cellRefs$current3 === void 0 || (_cellRefs$current3 = _cellRefs$current3[focusedRowIndex]) === null || _cellRefs$current3 === void 0 ? void 0 : _cellRefs$current3[focusedColumnIndex];

    /* Prevent cells from stealing focus from their children when they
     * receive focus, but still allow focus to move from a cell to a row.
     */
    if (!newFocusedCell.contains(document.activeElement) || hasFocusableRows && focusedColumnIndex === minColumnIndex) {
      focusCell(newFocusedCell);
    }
  }, [focusedRowIndex, focusedColumnIndex, hasFocusableRows, minColumnIndex, cellRefs]);
  useDidUpdate(function () {
    setFocusedRowIndex(headerRowIndex);
    setFocusedColumnIndex(minColumnIndex);
  }, [currentPage]);
  return {
    focusedRowIndex: focusedRowIndex,
    focusedColumnIndex: focusedColumnIndex,
    updateRowFocusIndex: updateRowFocusIndex,
    updateColumnFocusIndex: updateColumnFocusIndex,
    setFocusedColumnId: setFocusedColumnId,
    createRef: createRef,
    createPinnedContainerRef: createPinnedContainerRef,
    cellRefs: cellRefs
  };
}

export { AdvancedTable };
